import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChangeUserEmailAccountDialogComponent } from '../../dialogs/change-user-email-account-dialog/change-user-email-account-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TableOption } from '../../components/kiene-table/table-option';
import { ArrayTableColumn, DateTableColumn, TextTableColumn } from '../../components/kiene-table/table-column';
import { BenutzerrolleAendernDialogComponent } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzerrolle-aendern-dialog/benutzerrolle-aendern-dialog.component';
import { AnmeldenAlsAndererBenutzerDialogComponent } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/anmelden-als-anderer-benutzer-dialog/anmelden-als-anderer-benutzer-dialog.component';
import { BenutzerHinzufuegenDialogComponent } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzer-hinzufuegen-dialog/benutzer-hinzufuegen-dialog.component';
import { buildBenutzerHinzufuegenDialogConfig } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzer-hinzufuegen-dialog/benutzer-hinzufuegen-dialog.config';
import { BenutzerService } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzer.service';
import { AppService } from '../../../../projects/kiene-core/src/lib/services/app/app.service';
import { User } from '../../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzer';
import { Clipboard } from '@angular/cdk/clipboard';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({ selector: 'kiene-user', templateUrl: './user.component.html', styleUrls: ['./user.component.scss'] })
export class UserComponent implements OnInit {
    displayedColumns = ['titel', 'nachname', 'vorname', 'email', 'benutzerrolle', 'erstellt', 'options'];
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private readonly api: KieneTableService,
        private readonly messageService: MessageService,
        private readonly userService: BenutzerService,
        private readonly appService: AppService,
        private readonly clipboard: Clipboard,
        private localStorageService: LocalStorageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Benutzer';
        this.tableDescriptor.uniqueIdentifier = 'Benutzer';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'benutzer/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.detailsRoute = '/administration/benutzer/';
        this.tableDescriptor.nameOfIdField = 'benutzer_id';

        this.tableDescriptor.columns = this.getTableColumns();
        this.tableDescriptor.options = this.getTableOptions();

        this.tableDescriptor.permissionView = 51;
        this.tableDescriptor.permissionCreate = 52;

        this.tableDescriptor.initialSortColumn = 'nachname';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddUserDialog.bind(this);
    }

    getTableColumns() {
        const columns = [];
        columns.push(new TextTableColumn('titel', 'Titel'));
        columns.push(new TextTableColumn('vorname', 'Vorname'));
        columns.push(new TextTableColumn('nachname', 'Nachname'));
        columns.push(new TextTableColumn('email', 'E-Mail', { copyToClipboard: true }));
        columns.push(new ArrayTableColumn('benutzerrollen', 'Benutzerrollen', ['bezeichnung']));
        columns.push(new DateTableColumn('erstellt', 'Erstellt'));
        return columns;
    }

    openEmailAccountDialog(user: User) {
        const dialogRef = this.dialog.open(ChangeUserEmailAccountDialogComponent, {
            width: '800px',
            data: { user: user },
        });

        dialogRef.afterClosed().subscribe(() => {});
    }

    copyMail(user: User) {
        this.clipboard.copy(user.email);
        this.messageService.infoMessage('E-Mail Adresse kopiert!');
    }

    sendTestMail(user: User) {
        this.userService.sendTestMail(user).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Test E-Mail erfolgreich gesendet! Bitte auch im Spam Ordner nachschauen!',
                );
            },
            error => {
                this.messageService.errorMessage('Test E-Mail konnte nicht gesendet werden!', error);
            },
        );
    }

    openChangeUserRoleDialog(user: User) {
        const dialogRef = this.dialog.open(BenutzerrolleAendernDialogComponent, {
            width: '700px',
            data: { user: user },
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response != null) {
                this.messageService.infoMessage(
                    'Benutzer ' + response.vorname + ' ' + response.nachname + ' wurde erfolgreich geändert!',
                );
            }
            this.api.reload('openChangeUserRoleDialog');
        });
    }

    openAddUserDialog() {
        const dialogRef = this.dialog.open(
            BenutzerHinzufuegenDialogComponent,
            buildBenutzerHinzufuegenDialogConfig(this.appService.isMobileScreen),
        );
        dialogRef.afterClosed().subscribe(response => {
            if (response != null) {
                this.messageService.infoMessage(
                    'Benutzer ' + response.vorname + ' ' + response.nachname + ' wurde erfolgreich angelegt!',
                );
                this.api.reload('openAddUserDialog');
            }
        });
    }

    deleteUser(user: User) {
        this.userService.deleteUser(user).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Benutzer ' + user.vorname + ' ' + user.nachname + ' erfolgreich entfernt!',
                );
                this.api.reload('deleteUser');
            },
            error => {
                this.messageService.errorMessage(
                    'Löschen von Benutzer ' + user.vorname + ' ' + user.nachname + ' ist fehlgeschlagen!',
                    error,
                );
            },
        );
    }

    //Dialog für das anmelden als einen Anderen Benutzer
    openLogInAsThisUserDialog(user: User) {
        const dialogLogInAs = this.dialog.open(AnmeldenAlsAndererBenutzerDialogComponent, {
            width: '700px',
            data: { user: user, currentuser: this.localStorageService.getCurrentUser() },
        });

        //Nach dem schließen -> ausführen
        // dialogLogInAs.afterClosed().subscribe((response) => {
        //     if (response != null) {
        //         this.messageService.infoMessage(
        //             'Benutzer ' + response.vorname + ' ' + response.nachname + ' wurde erfolgreich angelegt!',
        //         );
        //         this.api.reload('openAddUserDialog');
        //     }
        // });
    }

    private getTableOptions() {
        const options = [];
        options.push(new TableOption(this.openChangeUserRoleDialog.bind(this), 'Benutzerrolle ändern', 'forward', 53));
        options.push(new TableOption(this.deleteUser.bind(this), 'Benutzer löschen', 'delete', 54));
        options.push(new TableOption(this.openEmailAccountDialog.bind(this), 'E-Mail Konto einrichten', 'email', 73));
        options.push(
            new TableOption(this.sendTestMail.bind(this), 'Test E-Mail an mich senden', 'forward_to_inbox', 59),
        );
        options.push(new TableOption(this.copyMail.bind(this), 'E-Mail Adresse kopieren', 'content_copy', 51));
        options.push(new TableOption(this.openLogInAsThisUserDialog.bind(this), 'Einloggen als', 'login', 70));
        return options;
    }
}
